import { EventType } from "interfaces";
import { StepsMenu } from "components/shared/event";
import { BuildEventPageStep } from "components/shared/event/sport/steps";

export const CreateSrpotEvent: React.FC = () => {

  return (
    <div className="flex flex-col gap-4 h-full">
      <div className="shrink-0">
        <StepsMenu eventType={EventType.SPORT} isEdit={false} />
      </div>
      <div className="flex-1"><BuildEventPageStep /></div>
    </div>
  );
};
